import { createRoutine } from 'redux-saga-routines'
import { ITimeTrackerState } from './timetracker.interface'

const initialPatientState: ITimeTrackerState = {
}

export const registerTimeLog = createRoutine('REGISTER_TIMELOG')
export const clearTimeLog = createRoutine('CLEAR_TIMELOG')

export default function patient(state = initialPatientState, action: any) {
    switch (action.type) {
        case registerTimeLog.TRIGGER: {
          const { patientId, timerCounter } = action.payload
          return Object.assign({}, {...state}, {[patientId]: timerCounter})
        }
        case clearTimeLog.TRIGGER: {
          const { patientId } = action.payload
          return Object.assign({}, {...state}, {[patientId]: 0})
        }

        default:
            return state
    }
}